import { X, GitCompareArrows } from "lucide-react";
import { Button } from "@openai/apps-sdk-ui/components/Button";
import { Image } from "@openai/apps-sdk-ui/components/Image";

/**
 * CompareFloatingBar - Fixed bottom bar showing selected listings for comparison
 */
export function CompareFloatingBar({ listings, onRemove, onCompare, onClear, isDark }) {
  if (!listings || listings.length === 0) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 border-t shadow-lg ${
        isDark ? "bg-zinc-900 border-white/10" : "bg-white border-black/10"
      }`}
    >
      <div className="max-w-4xl mx-auto px-4 py-3">
        <div className="flex items-center gap-4">
          {/* Selected listings preview */}
          <div className="flex-1 flex items-center gap-3 overflow-x-auto">
            <div className={`flex items-center gap-2 flex-shrink-0 ${isDark ? "text-white/70" : "text-black/70"}`}>
              <GitCompareArrows className="h-5 w-5" />
              <span className="text-sm font-medium">Karşılaştır ({listings.length}/3)</span>
            </div>

            <div className="flex gap-2">
              {listings.map((listing) => (
                <div
                  key={listing.id}
                  className={`relative flex-shrink-0 rounded-lg overflow-hidden ${
                    isDark ? "bg-white/10" : "bg-black/5"
                  }`}
                >
                  <div className="w-16 h-12">
                    {listing.image ? (
                      <Image
                        src={listing.image}
                        alt={listing.title || "İlan"}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className={`w-full h-full flex items-center justify-center ${isDark ? "bg-white/5" : "bg-black/5"}`}>
                        <span className={`text-[8px] ${isDark ? "text-white/30" : "text-black/30"}`}>Yok</span>
                      </div>
                    )}
                  </div>
                  <button
                    onClick={() => onRemove(listing.id)}
                    className={`absolute -top-1 -right-1 h-5 w-5 rounded-full flex items-center justify-center ${
                      isDark ? "bg-red-500 text-white" : "bg-red-500 text-white"
                    }`}
                  >
                    <X className="h-3 w-3" strokeWidth={2} />
                  </button>
                </div>
              ))}

              {/* Empty slots */}
              {Array.from({ length: 3 - listings.length }).map((_, i) => (
                <div
                  key={`empty-${i}`}
                  className={`w-16 h-12 rounded-lg border-2 border-dashed flex items-center justify-center ${
                    isDark ? "border-white/20" : "border-black/20"
                  }`}
                >
                  <span className={`text-xs ${isDark ? "text-white/30" : "text-black/30"}`}>+</span>
                </div>
              ))}
            </div>
          </div>

          {/* Actions */}
          <div className="flex gap-2 flex-shrink-0">
            <Button
              size="sm"
              variant="outline"
              onClick={onClear}
            >
              Temizle
            </Button>
            <button
              onClick={onCompare}
              disabled={listings.length < 2}
              className="px-3 py-1.5 bg-emerald-600 text-white text-sm font-medium rounded-lg hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              Karşılaştır
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompareFloatingBar;
